<template>
  <div>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeModal"
      :active.sync="supplyModal"
      :title="type === 'add' ? $t('Add Supplies Items'): $t('Edit Supply Items')"
      :buttons-hidden="true">
        <div class="px-4 mb-6">
          <p class="text-darkgray text-base text-center mb-8">{{ $t('Here you can add all the supplies you need') }}</p>
          <form :v-model="data">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div v-for="(item, index) in packagesSize" :key="item.index" class="col-span-1">
                <div :class="item.count > 0 ? '' : 'unshadow bg-gray'" class="supply-box text-center pt-4" v-if="item.short_code !== 'OSZ'">
                  <p :class="item.count > 0 ? 'text-primary' : 'text-gray'" class="font-medium">{{item.name.includes('(') ? item.name.split('(')[0] : item.name}}</p>
                  <span :class="item.count > 0 ? 'text-primary' : 'text-gray'" class="font-small">{{item.name.includes(')') && item.name.includes('(') ? item.name.split(' ')[item.name.split(' ').length - 1] : item.name}}</span>
                  <div class="relative h-24 flex items-center justify-center" >
                    <div class="h-3 w-full" :class="item.count > 0 ? 'bg-primary' : 'line-bg-gray'"></div>
                    <img :style="changeSize(item.short_code.split('-FLY')[0])" class="absolute top-1/2" src="../../../assets/images/pages/supply.svg"/>
                  </div>
                  <div :class="item.count > 0 ? 'bg-light-blue' : 'bg-dark-gray'" class="footer  py-2 flex items-center justify-center">
                    <vs-input-number v-if="item.count === 0" class="fake-plus w-full" min="0" v-validate="'required|numeric'" :name="`quantity-${index}`" v-model.number="item.count" :value="0"/>
                    <div v-else>
                      <vs-input-number min="0" v-validate="'required|numeric'"  :name="`quantity-${index}`" v-model.number="item.count" :value="0" class="w-full add-supply"/>
                    </div>
                  </div>
                </div>
                <span class="text-danger text-sm" v-show="errors.has(`quantity-${index}`)">{{ errors.first(`quantity-${index}`) ? errors.first(`quantity-${index}`).split(`-${index}`)[0] + errors.first(`quantity-${index}`).split(`-${index}`)[1]  : '' }}</span>
              </div>
            </div>
            <div class="total p-4 flex justify-between items-center">
              <span class="total-text w-2/5">{{ $t('Total Flyers Selected:') }}</span>
              <div class="grid grid-cols-2 w-3/5">
                <div v-for="(item, index) in packagesSize.filter(item => item.count > 0)" :key="item.index" class="col-span-1 mr-2">
                  <div class="bg-white py-2 px-1 ml-3 flex justify-between w-full" :class="index > 1 ? 'mb-0' : 'mb-3'" v-if="item.count > 0">
                    <div class="supply-total-text">
                      <span class="blue mr-1 text-sm">({{ item.count }})</span>
                      <span class="text-sm">{{item.name.split('(')[0]}}</span>
                    </div>
                    <div class="x-icon flex self-center justify-center h-5 w-5">
                      <feather-icon @click="removeSupply(item)" class="cursor-pointer" svgClasses="w-3 h-3" icon="XIcon"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="grid grid-cols-2 gap-4 mt-4">
          <button @click="closeModal" class="font-semibold btn disable-btn">{{ $t('Cancel') }}</button>
          <button @click="createSupply" v-if="type === 'add'" class="font-semibold btn" :class="packagesSize.find(item => item.count > 0) ? 'active-btn' : 'disable-btn pointer-events-none'">{{ $t('Add') }}</button>
          <button @click="updateSupply" v-else class="font-semibold btn" :class="packagesSize.find(item => item.count > 0) ? 'active-btn' : 'disable-btn pointer-events-none'">{{ $t('Save') }}</button>
        </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import i18nData from '../../../i18n/i18nData.js'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'

export default {
  props: ['packagesSize', 'supplyModal', 'type', 'data'],
  data () {
    return {
      apiURL: 'api/v1/supplies-items/',
      editMode: true,
      successCount: 0,
      supply: [],
      packagesSizeDic: {}
    }
  },
  watch: {
    type () {
      if (this.type === 'add') {
        this.packagesSize.forEach(element => {
          element.count = 0
        })
      }
    },
    data () {
      if (this.type === 'edit') {
        this.packagesSize = []
        this.data.supply_request_items.forEach(element => {
          this.packagesSize.push(
            {
              id: element.id,
              short_code: element.package_size.short_code,
              name: element.package_size.name,
              package_size: element.package_size.id,
              count: element.count
            }
          )
        })
      } else {
        this.packagesSize.forEach(element => {
          element.count = 0
        })
      }
    },
    'successCount' (val) {
      if (val === 5) {
        this.$vs.notify({
          color:'success',
          title:i18nData[this.$i18n.locale]['Success'],
          text: 'Supplies items have been updated successfully!',
          position: 'top-center'
        })
        this.$emit('supplyModal', false)
        this.$emit('loadSupplies')
      }
    }
  },
  methods: {
    changeSize (shortCode) {
      switch (shortCode) {
      case 'S':
        return 'width: 44px;height: 56px'
      case 'M':
        return 'width: 51px; height: 64px;'
      case 'L':
        return 'width: 57px; height: 72px;'
      case 'XL':
        return 'width: 63px; height: 80px;'
      }
    },
    removeSupply (item) {
      item.count = 0
      const index = this.packagesSize.indexOf(item)
      if (index > -1) {
        this.packagesSize.splice(index, 1) 
      }
      this.packagesSize.splice(index, 0, item)
    },
    updateSupply () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.successCount = 0
          this.packagesSize.forEach((element) => {
            element.count = Number(element.count)
            sendRequest(false, false, this, `api/v1/supplies-items/${element.id}/`, 'patch', element, true,
              () => {
                this.successCount = this.successCount + 1
              }
            )
          })
        }
      })
    },
    createSupply () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const packages = []
          this.packagesSize.forEach(element => {
            packages.push({
              package_size: element.id,
              count: Number(element.count)  
            })
          })
          sendRequest(false, false, this, 'api/v1/supplies/', 'post', {supplies_items: packages}, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Supply'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              if (this.$route.name === 'merchant-supplies-shop') {
                this.$emit('supplyModal', false)
                this.$emit('loadSupplies')
              } else {
                this.$router.push({
                  name: 'merchant-supplies-shop',
                  query: {
                    tab: 'Supplies Orders'
                  }
                })
              }
            }
          )
        }
      })
    },
    closeModal () {
      this.$emit('supplyModal', false)
      this.$emit('loadSupplies')
    },
    loadSupplyItems (Id) {
      sendRequest(false, false, this, `api/v1/supplies/${Id}/`, 'get', null, true, 
        (response) => {
          this.packagesSize = response.data.supply_request_items
        }
      )
    }
  },
  components: {
    ShipbluPrompt
  }
}
</script>
<style lang="scss">
.supply-img {
  transform: rotate(45deg);
}
.supply-box {
  box-shadow: 0px 2px 10px rgba(108, 132, 163, 0.32);
  border-radius: 6px;
}
.fake-plus {
  .vs-input-number--input {
    display: none !important;
  }
  .btn-plus {
    border-radius: 0.25rem !important; 
    background: #1c5bfe !important;
    padding: 1px !important;
    left: -10px !important;
    i {
      color: white !important; 
      border: 1px solid #1C5BFE;
      font-size: 14px !important;
    }
  }
  .btn-less {
    display: none !important;
    i {
      border: 1px solid #1C5BFE;
      color: #1C5BFE;
      font-size: 14px !important;
    }
  }  
}
.add-supply {
  .btn-plus {
    background: rgba(220, 238, 255, 0.5) !important;
    i {
      border: 1px solid #1C5BFE;
      color: #1C5BFE;
      font-size: 14px !important;
    }
  }
  .btn-less {
    background: rgba(220, 238, 255, 0.5) !important;
    i {
      border: 1px solid #1C5BFE;
      color: #1C5BFE;
      font-size: 14px !important;
    }
  }
}
.bg-light-blue {
  background: rgba(220, 238, 255, 0.5);
  border-radius: 0px 0px 6px 6px;
}
.vs-input-number .vs-input-number--input {
  min-width: 20px !important;
}
.vs-input-number-primary button:hover {
  -webkit-box-shadow:unset !important;
  box-shadow:unset !important;
}
.vs-input-number {
  margin: 0px !important;
  padding: 0px !important;
}
.bg-gray {
  background: #ECEEF2;
}
.bg-dark-gray {
  background: #DFE5EB;
}
.line-bg-gray {
  background: #9DADC2;
}
.text-gray {
  color: #6C84A3;
}
.vs-input-number--input {
  font-size: 13px !important;
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
}
.total {
  background: #F1F8FF;
}
.total-text {
  font-family: 'Montserrat';
  color: #0A3266;
}
.x-icon {
  background: rgba(157, 173, 194, 0.32);
  border-radius: 3px;
}
.supply-total-text {
  font-size: 14px;
  line-height: 18px;
}
.active-btn {
  color: #fff;
  font-weight: 500;
  background: #1C5BFE;
  box-shadow: 0px 2px 8px rgba(10, 50, 102, 0.32);
}
.disable-btn {
  background: #F1F3F6;
  color: #6C84A3;
}
.unshadow {
  box-shadow: unset !important;
}
.font-small{
  font-size: 12px;
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss"
</style>

